/* eslint import/first: 0 */
/* eslint global-require: 0 */

// set up Sentry error reporting as soon as possible so that we
// catch as many errors as possible
// import 'react-hot-loader/patch';
import './sentry';
import './polyfills';
import '@chama/statics/stylesheets';

import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
import { AppContainer } from 'react-hot-loader';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ApiClient from '@app/api/api-client';
import { ApiProvider } from '@app/context/ApiContext';
import RestrictionAreasGateway from '@app/gateways/RestrictionAreasGateway';
import ApplicationFacade from '@app/infrastructure/ApplicationFacade';
import NotificationManager from '@app/infrastructure/NotificationManager';
import { NotificationManagerProvider } from '@chama/ui-components/components/NotificationManagerContext';
import Root from './Root';
import configureStore from './store/configureStore';
import FirebaseClient from './firebase/FirebaseClient';

const api = new ApiClient();
const firebaseClient = new FirebaseClient();

const applicationFacade = new ApplicationFacade();

const store = configureStore({
  firebaseClient,
  api,
  applicationFacade,
});

applicationFacade.gateways.restrictionAreaGateway = new RestrictionAreasGateway(api);
applicationFacade.notificationManager = new NotificationManager(store);
applicationFacade.history = browserHistory;

const appRootNode = document.getElementById('root');

const renderApp = rootComponent => {
  const app = (
    <AppContainer warnings={false}>
      <ApiProvider api={api}>
        <NotificationManagerProvider notificationManager={applicationFacade.notificationManager}>
          <MuiThemeProvider>{rootComponent}</MuiThemeProvider>
        </NotificationManagerProvider>
      </ApiProvider>
    </AppContainer>
  );

  ReactDOM.render(app, appRootNode);
};

if (module.hot) {
  module.hot.accept('./Root', () => {
    const NextRoot = require('./Root').default;

    renderApp(<NextRoot store={store} history={browserHistory} />);
  });

  module.hot.accept('./reducer', () => {
    store.replaceReducer(require('./reducer').default);
  });
}

renderApp(<Root store={store} history={browserHistory} />);



// WEBPACK FOOTER //
// ./src/index.jsx